import React, { useState, memo, useCallback } from 'react'
import moment from 'moment'
import { useDispatch, useSelector } from 'react-redux'
import Link from 'next/link'
import styled from 'styled-components'

import { Text } from 'components/v2/Text'
import { Button } from 'components/v2/Button'
import { SingleDatePicker } from 'react-dates'
import { Row, Column } from 'components/v2/Grid'
import { NextImage } from 'components/v2/NextImage'
import { HeaderNavLogo } from 'components/v2/Header'
import { CalendarTwo, ThinChevron } from 'components/v2/Icons'

import { collapse, updateFilter } from 'redux/modules/filters'

const CollapseHeader = () => {
  const dispatch = useDispatch()
  const [focus, setFocus] = useState(false)

  const onDateChange = useCallback(
    date => {
      dispatch(
        updateFilter({
          startDate: moment(new Date(date)).format('YYYY-MM-DD'),
          endDate: moment(date).add(4, 'days')
        })
      ),
        window.scrollTo({
          top: 0,
          behavior: 'smooth'
        })
    },
    [dispatch]
  )

  const { filters } = useSelector(state => ({
    filters: state.filters
  }))

  const onToggleMoreFiltersVisibility = useCallback(() => dispatch(collapse()), [dispatch])

  return (
    <Column id='wrapper-header-search-filters' position='fixed' top='0' width='100vw'>
      <Column id='header-search-and-filters' justifyContent='center'>
        <Row alignItems='center' justifyContent={['center', 'space-between']} className='container'>
          <Column alignItems='center' className='hide-on-mobile'>
            <Link href='/'>
              <HeaderNavLogo display={['none', 'flex']}>
                <NextImage
                  src='/static/images/logo-vittude-v2.svg'
                  alt='Vittude'
                  title='Logo da Vittude'
                  width={130}
                  height={130}
                />
              </HeaderNavLogo>
            </Link>
          </Column>
          <Row
            alignItems='center'
            width={['100%', '500px']}
            justifyContent={['center', 'space-between']}
          >
            <Filter width={['137px', '154px']} onClick={onToggleMoreFiltersVisibility}>
              <NextImage
                src='/static/images/filters.svg'
                alt='Ícone volume para menu'
                title='Ícone volume para menu'
                width={20}
                height={20}
              />
              <Text ml='10px' variant='small' color='darkPrimary' fontWeight='600'>
                Filtros
              </Text>
            </Filter>
            <DateContainer
              onClick={() => setFocus(!focus)}
              className='filter-field'
              id='date-filter'
            >
              <DatePicker cy_id='input-date' className='date-picker'>
                <CalendarTwo color='#FF7708' size='18px' />
                <Column
                  flexDirection={['column', 'row']}
                  alignItems={['flex-start', 'center']}
                  pl={['0', '3px']}
                  ml='11px'
                >
                  <Text variant='small' color='gray.n500' mr='2px'>
                    A partir de:
                  </Text>
                  <ContentDate>
                    <SingleDatePicker
                      readOnly
                      date={moment(new Date(filters?.startDate))}
                      onDateChange={onDateChange}
                      focused={focus}
                      onFocusChange={() => setFocus()}
                      noBorder={true}
                      displayFormat='DD/MM/Y'
                      id='startDate'
                      numberOfMonths={1}
                      hideKeyboardShortcutsPanel
                    />
                  </ContentDate>
                </Column>
              </DatePicker>
              <ImageIndex>
                <ThinChevron height='16px' variant={!focus ? 'top' : 'down'} />
              </ImageIndex>
            </DateContainer>
          </Row>
        </Row>
      </Column>
    </Column>
  )
}

export default memo(CollapseHeader)

const Filter = styled(Button)`
  background: transparent;
  border: 1px solid #ff7708;
  border-radius: 6px;
  min-width: 137px;
  height: 48px;
  justify-content: center;
  align-items: center;
  display: flex;
`
const DateContainer = styled(Row)`
  margin-left: 10px;
  cursor: pointer;
  align-items: center;
  background: white;
  border: 0.5px solid #bdc3c7;
  border-radius: 4px;
  height: 48px;
  max-width: 325px;
  width: 100%;
  padding-right: 15px;
  @media (max-width: 992px) {
    max-width: 398px;
    width: 100%;
  }
  @media (max-width: 639px) {
    max-width: 186px;
    width: 100%;
    height: 51px;
  }
`
const ImageIndex = styled.div`
  z-index: 2;
`
const DatePicker = styled.div`
  display: flex;
  box-shadow: 0;
  border: 0;
`
const ContentDate = styled.div`
  #startDate {
    width: 90px;
  }
  .DateInput {
    width: 90px;
  }
  .DateInput_input {
    cursor: pointer !important;
    font-size: 14px !important;
  }
  .DateInput_fangStroke {
    display: none;
  }
  .SingleDatePicker_picker {
    top: 39px !important;
    left: -110px !important;

    @media (max-width: 375px) {
      left: -170px !important;
    }
  }
  .DayPicker {
    width: 313px !important;
    @media (max-width: 320px) {
      width: 186px !important;
    }
  }
  .DayPicker_transitionContainer {
    width: 313px !important;
  }
  .CalendarMonthGrid {
    @media (max-width: 320px) {
      left: 0px !important;
    }
  }
  .DayPicker_weekHeader {
    @media (max-width: 320px) {
      left: -8px !important;
    }
  }
  .DayPicker_focusRegion {
    @media (max-width: 320px) {
      width: 186px !important;
    }
  }
`
